module.exports = __webpack_public_path__ + "static/media/home-375.1b39bb47.webp";